// extracted by css-extract-rspack-plugin
export default {"listContainer":"SharedListContainer-module__listContainer__A4WkZ","primerActionBar":"SharedListContainer-module__primerActionBar__Tixik"};